import React from "react";

import { Icon, Thumbnail } from "@culturehq/components";
import { getDuration, getImageFromStory, isMultiImageStory } from "app/utils";
import imagesSizes from "constants/imagesSizes";

import SocialChannel from "components/common/SocialChannel";
import LazyEditorOutput from "components/editor/LazyEditorOutput";

import TrendsetterBadge from "./TrendsetterBadge";

const Singular = ({
  item: { entity: story }, onClick, isTrendsetter = false, showTags = false, socialShare = undefined
}) => {
  const backgroundImage = `url(${story.media.mediaType === "video" ? story.media?.thumbnail : getImageFromStory(imagesSizes.NORMAL, story)})`;
  const { creator } = story;

  const handleClick = () => {
    if (onClick) {
      onClick(0);
    }
  };

  return (
    <div className="FeedItem__preview__photo_created_multiple" key="preview">
      <div className="PhotoGroup PhotoGroup-1">
        <div className="PhotoGroup__thumbnail" onClick={handleClick} role="button" tabIndex={0}>
          <div className="Story__information--feed">
            <div className="background-container">
              <LazyEditorOutput output={story.body} showTags={false} preview />
              <div className="Story_Badges__Container">
                {isTrendsetter && <TrendsetterBadge justIcon />}
                {story?.socialShares?.map(share => share.socialType).filter(
                  (value, index, self) => (self.indexOf(value) === index)
                ).map(type => (
                  <SocialChannel key={type} justIcon socialType={type} />
                ))}
              </div>
              <div className="Story__creator">
                <Thumbnail image={creator.avatar.thumbUrl} />
                <span>{creator.name}</span>
              </div>
              {story.media.mediaType === "video" && (
                <span className="Story__badge">
                  <Icon icon="play-no-border" />
                  {getDuration(story.media?.duration)}
                </span>
              )}
              {isMultiImageStory(story) && (
                <div className="MultiImage__container">
                  <Icon icon="images" />
                </div>
              )}
            </div>
          </div>
          <div
            className="PhotoGroup__wrapper"
            style={{ backgroundImage }}
          />
        </div>
      </div>
    </div>
  );
};

export default Singular;
